import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout';
import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import Drp_DocSetting from '../AccountDocSettings/Drp_DocSetting.js';
import moment from 'moment-jalaali';
import DatePicker from 'react-datepicker2';
import PN from "persian-number";



const PaymentReceivedIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    const rowKey = 'Id';
    let navigate = useNavigate();
    const UserRef = useRef()
    const DocSettingRef = useRef();
    const [List, setList] = useState([]);
    const [FiscalYearId, setFiscalYearId] = useState(localStorage.getItem("FiscalYearId"));

    const [Acc_CTitle, setAcc_CTitle] = useState('');
    const [Sub_Acc_LTitle1, setSub_Acc_LTitle1] = useState('');
    const [DocSettingId, setDocSettingId] = useState(General.GuidEmpty());
    const [BeginDate, setBeginDate] = useState(moment(new Date()).add("Day", -7));
    const [EndDate, setEndDate] = useState(moment(new Date()));
    const [expandedRowKeys, setExpandedRowKeys] = React.useState([0]);
    const [loading, setLoading] = React.useState(false)

    //#endregion

    const handleExpanded = (rowData) => {
        let open = false;
        const nextExpandedRowKeys = [];
        expandedRowKeys.forEach(key => {

            if (key === rowData[rowKey]) {
                open = true;
            } else if (key != undefined) {
                nextExpandedRowKeys.push(key);
            }
        });

        if (!open) {
            nextExpandedRowKeys.push(rowData[rowKey]);
        }

        setExpandedRowKeys(nextExpandedRowKeys);
    };


    const BeginDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setBeginDate(moment(m, 'jYYYY/jMM/jDD'));
    }

    const EndDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setEndDate(moment(m, 'jYYYY/jMM/jDD'));
    }





    //#region Methods


    const Search = () => {
        var RequestOptions = {
            data: {
                'FiscalYearId': FiscalYearId * 1,
                'DocSettingId': DocSettingId,
                'Sub_Acc_LTitle1': Sub_Acc_LTitle1,
                'Acc_CTitle': Acc_CTitle,
                'DocState': -1

            },
            url: General.ApiRoute() + "/PaymentReceived/SearchHeader",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'BeginDate': BeginDate != null ? moment(BeginDate.format()).format("jYYYY/jMM/jDD") : "",
                'EndDate': EndDate != null ? moment(EndDate.format()).format("jYYYY/jMM/jDD") : "",
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    var tmp = []

                    for (var i = 0; i < result.data.length; i++) {
                        tmp.push({
                            row: i + 1,
                            Id: result.data[i].id,
                            CreateUser: result.data[i].createUser,
                            DOCSetting: result.data[i].docSetting,
                            Number: result.data[i].number,
                            PayDate: result.data[i].payDate,
                            PayTime: result.data[i].payTime,
                            DocState: result.data[i].docState,
                            Acc_CCode: result.data[i].acc_CCode,
                            Acc_CTitle: result.data[i].acc_CTitle,
                            InsertDateTime: result.data[i].insertDateTime,
                            Sub_Acc_Id1: result.data[i].sub_Acc_Id1,
                            Sub_Acc_Id2: result.data[i].sub_Acc_Id2,
                            Sub_Acc_Id3: result.data[i].sub_Acc_Id3,
                            Sub_Acc_LCode1: result.data[i].sub_Acc_LCode1,
                            Sub_Acc_LCode2: result.data[i].sub_Acc_LCode2,
                            Sub_Acc_LCode3: result.data[i].sub_Acc_LCode3,
                            Sub_Acc_LTitle1: result.data[i].sub_Acc_LTitle1,
                            Sub_Acc_LTitle2: result.data[i].sub_Acc_LTitle2,
                            Sub_Acc_LTitle3: result.data[i].sub_Acc_LTitle3,
                            Comment: result.data[i].comment,
                            TotalPrice: PN.sliceNumber(result.data[i].totalPrice),
                            children: result.data[i].children,

                        })
                    }
                    setList(tmp)
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )

    }

    const Print = (id) => {
        // navigate("/PrintPaymentReceived")
        // localStorage.setItem("BackPage", "PaymentReceived");
        window.open("/PrintPaymentReceived", "_blank");
        localStorage.setItem("PaymentReceivedId", id)
    }


    const ShowNew = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 40);
        myHeaders.append("Operation", 1);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage("AccessDenied")), 'topCenter')
                    }
                    else {
                        localStorage.setItem("PaymentReceivedId", General.GuidEmpty())
                        navigate("/InsertPaymentReceived")

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }


    const ShowEdit = (Id) => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 40);
        myHeaders.append("Operation", 2);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage("AccessDenied")), 'topCenter')
                    }
                    else {
                        localStorage.setItem("PaymentReceivedId", Id)
                        navigate("/InsertPaymentReceived")

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }


    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 40);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        Search();
                        DocSettingRef.current.Bind(-1, 2, -1, -2);
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }


    const handelKeyDown = (e, row) => {
        if (e.key == "Enter") {
            Search();
        }
        if (e.shiftKey && e.code === "KeyN") {
            ShowNew();
        }

    }

    useEffect(() => {
        CheckPermission();
        document.title = "لیست رسید پرداخت";
        const inputElement = document.querySelector('.FocusItem');
        if (inputElement) {
            inputElement.focus();
        }
    }, [])
    //#endregion

    return (

        <Layout title="لیست رسید پرداخت">


            <div className="h-100 p-1" onKeyDown={handelKeyDown}>
                <rsuite.Panel className="bg-white ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={Search}>  جستجو</rsuite.Button>
                                <rsuite.Button appearance="primary" color="green" size="xs" className="m-1" onClick={ShowNew}>  جـــدید</rsuite.Button>

                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <rsuite.Row className='p-1'>

                        <rsuite.Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                            <label> از تاریخ </label>
                            <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={BeginDate} onChange={BeginDate_Change} />
                        </rsuite.Col>
                        <rsuite.Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                            <label>تا تاریخ </label>
                            <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={EndDate} onChange={EndDate_Change} />
                        </rsuite.Col>
                        {/* <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label> شماره رسید </label>
                            <rsuite.Input value={Number} onChange={(e) => setNumber(e)} />
                        </rsuite.Col> */}
                        <rsuite.Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={12}>
                            <label>نوع عملیات </label>
                            <Drp_DocSetting value={DocSettingId} onChange={(value, title) => (setDocSettingId(value))} ref={DocSettingRef} />
                        </rsuite.Col>
                        <rsuite.Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                            <label> حساب معین </label>
                            <rsuite.Input value={Acc_CTitle} onChange={(e) => setAcc_CTitle(e)} />
                        </rsuite.Col>
                        <rsuite.Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                            <label> حساب تفصیلی </label>
                            <rsuite.Input value={Sub_Acc_LTitle1} onChange={(e) => setSub_Acc_LTitle1(e)} />
                        </rsuite.Col>
                    </rsuite.Row>

                    <div className="h-90 p-1">
                        <div className="h-100-y">

                            <rsuite.Panel className="bg-white mt-2">

                                <rsuite.Table
                                    rowKey={rowKey}
                                    data={List}

                                    rowExpandedHeight={rowData => {
                                        return (
                                            rowData.children.length == 1 ? 100 : rowData.children.length == 2 ? 160 : rowData.children.length * 80)
                                    }}

                                    rowHeight={80}

                                    height={700}
                                    expandedRowKeys={expandedRowKeys}
                                    loading={loading}

                                    renderRowExpanded={rowData => {
                                        return (
                                            <div>
                                                <rsuite.Table
                                                    data={rowData.children}
                                                    loading={loading}
                                                    autoHeight={true}
                                                    className='text-black-50'
                                                    wordWrap
                                                >
                                                    <rsuite.Table.Column flexGrow={1} fullText resizable>
                                                        <rsuite.Table.HeaderCell> نوع  </rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell>
                                                            {(rowData) => {
                                                                return (
                                                                    <>
                                                                        {rowData.payTypeComment}                                                                          {rowData.transferTypeComment}
                                                                    </>

                                                                )
                                                            }}
                                                        </rsuite.Table.Cell>
                                                    </rsuite.Table.Column>
                                                    <rsuite.Table.Column flexGrow={1} fullText resizable>
                                                        <rsuite.Table.HeaderCell> تاریخ / ساعت  </rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell>
                                                            {(rowData) => {
                                                                return (
                                                                    <>
                                                                        {rowData.payDate} / {rowData.payTime}                                                                          {rowData.transferTypeComment}
                                                                    </>

                                                                )
                                                            }}
                                                        </rsuite.Table.Cell>
                                                    </rsuite.Table.Column>
                                                    <rsuite.Table.Column flexGrow={5} fullText resizable>
                                                        <rsuite.Table.HeaderCell> شرح  </rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell>
                                                            {(rowData) => {
                                                                return (
                                                                    <>
                                                                        <text className={rowData.payType == 1 ? "" : 'hide'}>
                                                                            صندوق : {rowData.fund}
                                                                        </text>
                                                                        <text className={rowData.payType == 4 ? "" : 'hide'}>
                                                                            بانک : {rowData.bankAccount}
                                                                            <text className={rowData.recieptNo != "" ? "" : 'hide'}> - شماره رسید : {rowData.recieptNo}  </text>
                                                                            <text className={rowData.destinationAccountNo != "" ? "" : 'hide'}> - شماره حساب مقصد : {rowData.destinationAccountNo}  </text>
                                                                        </text>
                                                                        <text className={rowData.payType == 5 ? "" : 'hide'}>
                                                                            بانک : {rowData.bankAccount}
                                                                            - سریال  : {rowData.checkNo}
                                                                            - سر رسید : {rowData.checkDate}
                                                                            <text className={rowData.byCheck != "" ? "" : 'hide'}> - در وجه  : {rowData.byCheck}  </text>
                                                                            - وضعیت : {rowData.confirmCheck == 0 ? "سنتی" : rowData.confirmCheck == 1 ? "صیادی - تایید نشده" : "صیادی - تایید شده"}
                                                                        </text>
                                                                        <text className={rowData.payType == 6 ? "" : 'hide'}>
                                                                            صادر کننده : {rowData.recieptItem_CheckBy}
                                                                            <text className={rowData.recieptItem_Bank != "" ? "" : 'hide'}> - بانک  : {rowData.recieptItem_Bank}  </text>
                                                                            <text className={rowData.recieptItem_Branch != "" ? "" : 'hide'}> - شعبه  : {rowData.recieptItem_Branch}  </text>

                                                                            - سریال  : {rowData.recieptItem_CheckNo}
                                                                            - سر رسید : {rowData.recieptItem_CheckDate}
                                                                            - وضعیت : {rowData.confirmCheck == 0 ? "سنتی" : rowData.confirmCheck == 1 ? "صیادی - منتقل نشده" : "صیادی - منتقل شده"}
                                                                        </text>
                                                                        <text className={rowData.payType == 7 ? "" : 'hide'}>
                                                                            انتقال حساب به  : {rowData.شccountTransfer}
                                                                        </text>
                                                                    </>

                                                                )
                                                            }}
                                                        </rsuite.Table.Cell>
                                                    </rsuite.Table.Column>

                                                    <rsuite.Table.Column flexGrow={2} fullText resizable>
                                                        <rsuite.Table.HeaderCell> توضیحات</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell dataKey="comment" />
                                                    </rsuite.Table.Column>


                                                    <rsuite.Table.Column flexGrow={1} >
                                                        <rsuite.Table.HeaderCell> مبلغ (ریال)</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell>
                                                            {(rowData) => {
                                                                return (
                                                                    <text>
                                                                        {PN.sliceNumber(rowData.price)}
                                                                    </text>

                                                                )
                                                            }}
                                                        </rsuite.Table.Cell>
                                                    </rsuite.Table.Column>


                                                </rsuite.Table>
                                            </div>
                                        );
                                    }}

                                >

                                    <rsuite.Table.Column className="w-10p" align="center" fixed >
                                        <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    {expandedRowKeys.some(key => key === rowData[rowKey]) ? (
                                                        <BiIcon.BiMinusCircle size='12px' color='red' appearance="subtle"
                                                            onClick={() => {
                                                                handleExpanded(rowData);
                                                            }} />
                                                    ) : (
                                                        <BiIcon.BiPlusCircle size='12px' color='green' appearance="subtle"
                                                            onClick={() => {
                                                                handleExpanded(rowData);
                                                            }} />
                                                    )}

                                                    &nbsp;&nbsp; {rowData.row}
                                                </>


                                            }}

                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column fullText flexGrow={2} resizable>
                                        <rsuite.Table.HeaderCell>تاریخ ثبت سیستمی</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="InsertDateTime" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={2} resizable>
                                        <rsuite.Table.HeaderCell>تاریخ رسید</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="PayDate" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell>شماره </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Number" />
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column fullText flexGrow={2} resizable>
                                        <rsuite.Table.HeaderCell>نوع رسید</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="DOCSetting" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={2} resizable>
                                        <rsuite.Table.HeaderCell>کاربر  </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="CreateUser" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={3} resizable>
                                        <rsuite.Table.HeaderCell> مشخصات حساب </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell >

                                            {(rowData) => {
                                                return (
                                                    <>
                                                        <text>
                                                            حساب معین :  {rowData.Acc_CTitle} [{rowData.Acc_CCode}] <br />

                                                        </text>
                                                        <text className={rowData.Sub_Acc_Id1 != General.GuidEmpty() ? "" : 'hide'}>
                                                            {rowData.Sub_Acc_LTitle1} [{rowData.Sub_Acc_LCode1}] <br />
                                                        </text>
                                                        <text className={rowData.Sub_Acc_Id2 != General.GuidEmpty() ? "" : 'hide'}>
                                                            {rowData.Sub_Acc_LTitle2} [{rowData.Sub_Acc_LCode2}] <br />
                                                        </text>
                                                        <text className={rowData.Sub_Acc_Id3 != General.GuidEmpty() ? "" : 'hide'}>
                                                            {rowData.Sub_Acc_LTitle3} [{rowData.Sub_Acc_LCode3}]
                                                        </text>
                                                    </>

                                                )
                                            }}

                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={3} resizable>
                                        <rsuite.Table.HeaderCell>شرح  </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Comment" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={2} resizable>
                                        <rsuite.Table.HeaderCell>مبلغ  </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="TotalPrice" />
                                    </rsuite.Table.Column>


                                    <rsuite.Table.Column fixed="right" width={60} >
                                        <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>

                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    <rsuite.Whisper placement="autoVerticalStart" trigger="click" speaker={
                                                        <rsuite.Popover full className='PopoverMenu'>
                                                            <rsuite.Dropdown.Menu  >
                                                                {/* <rsuite.Dropdown.Item onClick={() => ShowDetail(rowData.Id)}>جزییات</rsuite.Dropdown.Item> */}
                                                                <rsuite.Dropdown.Item onClick={() => ShowEdit(rowData.Id)}>ویرایش</rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item onClick={() => Print(rowData.Id)}>چاپ   </rsuite.Dropdown.Item>
                                                            </rsuite.Dropdown.Menu>
                                                        </rsuite.Popover>
                                                    }>
                                                        <rsuite.IconButton appearance="subtle" icon={<BiIcon.BiDotsHorizontalRounded />} />
                                                    </rsuite.Whisper>
                                                </>
                                            }}
                                        </rsuite.Table.Cell>

                                    </rsuite.Table.Column>
                                </rsuite.Table>

                            </rsuite.Panel>

                        </div>
                    </div >
                    <rsuite.Row>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <rsuite.Divider></rsuite.Divider>
                            <small><b> Shift+N :</b> جدید<b>| Enter :</b> جستجو </small>
                        </rsuite.Col>
                    </rsuite.Row>

                </rsuite.Panel >
            </div >
        </Layout >

    )
}

export default PaymentReceivedIndex;